import { render, staticRenderFns } from "./PdfArticle.vue?vue&type=template&id=18192839&scoped=true"
import script from "./PdfArticle.vue?vue&type=script&lang=js"
export * from "./PdfArticle.vue?vue&type=script&lang=js"
import style0 from "./PdfArticle.vue?vue&type=style&index=0&id=18192839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18192839",
  null
  
)

export default component.exports